import React from 'react';
import type { JSX, TextareaHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

type Props = {
  className?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ className = '', ...rest }, ref): JSX.Element => {
    return (
      <div className={cn('relative', className)}>
        <textarea
          ref={ref}
          className={cn(
            'block w-full rounded-md border-0 bg-white px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-amber-800 focus:ring-inset sm:text-sm sm:leading-6',
          )}
          {...rest}
        />
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
